










































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import InterestRateType from '@/models/Products/InterestRateType';
import ListUtils from '@/lib/listUtils';
import PeriodType from '@/models/Shared/PeriodType';
import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositOverdraftInterestSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType;

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    async beforeMount() {
        if (this.isCreate) {
            await ProductWizardModule.getRateSources();
        }
        return ProductDetailsModule.getRateSources();
    }

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositCurrentAccount && ProductWizardModule.createProductViewModel.depositOverdraftSettingsAvailable) {
                ProductWizardModule.createProductViewModel.depositOverdraftInterestSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get rateSourceOptions() {
        if (this.isCreate) {
            return ProductWizardModule.rateSources;
        }
        return ProductDetailsModule.rateSources;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get interestCalculatedOnOptions() {
        return ListUtils.interestCalculatedOnOptions();
    }

    get interestPostedTypeOptions() {
        return ListUtils.interestPostedTypeOptions();
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get nonWorkingDaysOptions() {
        return ListUtils.nonWorkingDaysOptions();
    }

    get dayOfWeekOptions() {
        return ListUtils.dayOfWeekOptions();
    }

    get dayOfMonthOptions() {
        return ListUtils.dayOfMonthOptions();
    }

    get monthOptions() {
        return ListUtils.monthOptions();
    }

    get daysInYearOptions() {
        return ListUtils.interestDaysInYearOptions();
    }

    get baseRateOptions() {
        return ListUtils.interestBaseRateOptions();
    }

    // Resets valies for rate source ID based on rate type to avoid sending bad data to API
    @Watch('productVM.depositOverdraftInterestSettings.rateType')
    async onRateTypeChanged(rateType: string) {
        if (rateType === InterestRateType.Fixed) {
            this.productVM.depositOverdraftInterestSettings.rateSourceId = undefined;
        }
    }

    // Resets valies for accruedPeriod based on periodType to avoid sending bad data to API
    @Watch('productVM.depositOverdraftInterestSettings.accruedPeriodType')
    async onAccruedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.productVM.depositOverdraftInterestSettings.accruedPeriodOnDayOfWeek = undefined;
        }
    }

    // Resets valies for postedPeriod based on periodType to avoid sending bad data to API
    @Watch('productVM.depositOverdraftInterestSettings.postedPeriodType')
    async onPostedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnDayOfWeek = undefined;
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnDayOfMonth = undefined;
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnDayOfMonth = undefined;
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnDayOfWeek = undefined;
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.productVM.depositOverdraftInterestSettings.postedPeriodOnDayOfWeek = undefined;
        }
    }

}
